<template>
    <div v-if="$store.state.userData && $store.state.userData.user_group_id == 1 && $store.state.userData.company_type == 1" class="admin">
        <h1 class="headline">Admin Interface</h1>
        <div v-if="Object.keys(latestPublishRequests).length > 0" class="admin__box publish_requests" :class="{'focus': focus == 'publish_requests'}">
            <div style="display: flex;justify-content:space-between;">
                <h2 @click="toggleFocus('publish_requests')">Latest Publish Requests</h2>
                <a @click="reloadPublishRequests()" class="btn">Reload</a>
            </div>
            <div class="content">
                <table>
                    <thead>
                        <tr>
                            <td>ID</td>
                            <td>Version</td>
                            <td>Company</td>
                            <td>Request</td>
                            <td>Plugin Name</td>
                            <td>Template</td>
                            <td>Page</td>
                            <td>Timestamp</td>
                            <td>Aktionen</td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="request in latestPublishRequests" :key="request.id">
                            <tr>
                                <td><b>{{request.id}}</b></td>
                                <td>{{request.number}}</td>
                                <td>{{request.company}} ({{request.company_id}})</td>
                                <td>{{request.displayname}} ({{request.user_email}})</td>
                                <td>{{request.plugin}} ({{request.plugin_id}})</td>
                                <td><a target="_blank" :href="'https://api.library.loxone.com/files/' + request.company_name + '-' + request.company_id + '/plugins/' + request.plugin_name + '-' + request.plugin_id + '/versions/'+request.number+'/' + request.plugin_name + '.xml'">Template</a></td>
                                <td><a target="_blank" :href="'https://library.loxone.com/detail/preview-' + request.plugin_id + '/overview'">Page</a></td>
                                <td>{{request.insert_timestamp}}</td>
                                <td>
                                    <svg @click="accept(request)" class="interactive" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-349d690c=""><g id="icons-/-filled-/-checkmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-349d690c=""><path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350" data-v-349d690c=""></path></g></svg>
                                    &nbsp;&nbsp;&nbsp;
                                    <svg @click="toggleComment(request)" class="interactive" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-349d690c=""><g id="icons-/-filled-/-delete" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-349d690c=""><path d="M12,0 C18.6281739,0 24,5.37182609 24,12 C24,18.6281739 18.6281739,24 12,24 C5.37182609,24 0,18.6281739 0,12 C0,5.37182609 5.37182609,0 12,0 Z M8.11289944,6.70970461 C7.72060824,6.40467972 7.15337718,6.43240926 6.79289322,6.79289322 C6.40236893,7.18341751 6.40236893,7.81658249 6.79289322,8.20710678 L6.79289322,8.20710678 L10.585,12 L6.79289322,15.7928932 L6.70970461,15.8871006 C6.40467972,16.2793918 6.43240926,16.8466228 6.79289322,17.2071068 C7.18341751,17.5976311 7.81658249,17.5976311 8.20710678,17.2071068 L8.20710678,17.2071068 L12,13.415 L15.7928932,17.2071068 L15.8871006,17.2902954 C16.2793918,17.5953203 16.8466228,17.5675907 17.2071068,17.2071068 C17.5976311,16.8165825 17.5976311,16.1834175 17.2071068,15.7928932 L17.2071068,15.7928932 L13.415,12 L17.2071068,8.20710678 L17.2902954,8.11289944 C17.5953203,7.72060824 17.5675907,7.15337718 17.2071068,6.79289322 C16.8165825,6.40236893 16.1834175,6.40236893 15.7928932,6.79289322 L15.7928932,6.79289322 L12,10.585 L8.20710678,6.79289322 Z" id="Combined-Shape" fill="#E73246" fill-rule="nonzero" data-v-349d690c=""></path></g></svg>
                                </td>
                            </tr>
                            <tr v-if="request.commentVisible">
                                <td colspan="7">
                                    <textarea class="styled" v-model="request.message"  style="width:100%;resize: none;height:100px;" placeholder="Comment (at least 10 characters)"></textarea>
                                </td>
                                <td>
                                    <a class="btn" @click="decline(request)">Decline</a>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="admin__box publish_requests loading">&nbsp;</div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {
    },
    data() {
        return {
            latestUsers: [],
            latestCompanies: [],
            latestPublishRequests: [],
            latestPlugins: [],
            latestVersions: [],
            serverInfo: [],
            focus: '',
            changelog: [],
        }
    },
    methods: {
        reloadPublishRequests() {
            this.latestPublishRequests = [];
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/adminLoadLatestPublishRequests',
            })
            .then(resp => {
                this.latestPublishRequests = resp.data;
            });
        },
        loadIOs(id) {
            var ioInfo = new FormData();
            ioInfo.append('version_id', id)
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadPluginIOs',
                data: ioInfo,
            }).then(response => {
            });
        },
        toggleDetailVisible(plugin) {
            plugin.detailVisible = !plugin.detailVisible;
        },
        toggleFocus(data) {
        },
        trueFalse(validator, use_icons = false) {
            var false_icon = '<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-349d690c=""><g id="icons-/-filled-/-delete" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-349d690c=""><path d="M12,0 C18.6281739,0 24,5.37182609 24,12 C24,18.6281739 18.6281739,24 12,24 C5.37182609,24 0,18.6281739 0,12 C0,5.37182609 5.37182609,0 12,0 Z M8.11289944,6.70970461 C7.72060824,6.40467972 7.15337718,6.43240926 6.79289322,6.79289322 C6.40236893,7.18341751 6.40236893,7.81658249 6.79289322,8.20710678 L6.79289322,8.20710678 L10.585,12 L6.79289322,15.7928932 L6.70970461,15.8871006 C6.40467972,16.2793918 6.43240926,16.8466228 6.79289322,17.2071068 C7.18341751,17.5976311 7.81658249,17.5976311 8.20710678,17.2071068 L8.20710678,17.2071068 L12,13.415 L15.7928932,17.2071068 L15.8871006,17.2902954 C16.2793918,17.5953203 16.8466228,17.5675907 17.2071068,17.2071068 C17.5976311,16.8165825 17.5976311,16.1834175 17.2071068,15.7928932 L17.2071068,15.7928932 L13.415,12 L17.2071068,8.20710678 L17.2902954,8.11289944 C17.5953203,7.72060824 17.5675907,7.15337718 17.2071068,6.79289322 C16.8165825,6.40236893 16.1834175,6.40236893 15.7928932,6.79289322 L15.7928932,6.79289322 L12,10.585 L8.20710678,6.79289322 Z" id="Combined-Shape" fill="#E73246" fill-rule="nonzero" data-v-349d690c=""></path></g></svg>'
            var true_icon = '<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-349d690c=""><g id="icons-/-filled-/-checkmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-349d690c=""><path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C7.712813,24 3.75128874,21.712813 1.60769517,18 C-0.535898391,14.2871871 -0.535898391,9.7128129 1.60769517,6 C3.75128874,2.287187 7.712813,0 12,0 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350" data-v-349d690c=""></path></g></svg>';
            if(validator == 1) {
                if(use_icons) {
                    return true_icon;
                }
                return "True";
            }else {
                if(use_icons) {
                    return false_icon;
                }
                return "False"
            }
        },
        toggleComment(request) {
            request.commentVisible = !request.commentVisible;
        },
        accept(request) {
            var versionInfo = new FormData();
            versionInfo.append('task', 'acceptPublish')
            versionInfo.append('version_id', request.id)
            versionInfo.append('to', request.user_email)
            versionInfo.append('name', request.displayname)
            versionInfo.append('company_name', request.company)
            versionInfo.append('company_id', request.company_id)
            versionInfo.append('plugin_name', request.plugin)
            versionInfo.append('plugin_id', request.plugin_id)
            versionInfo.append('version_number', request.number)
            versionInfo.append('user_id', this.$store.state.userData.user_id)
            versionInfo.append('text', request.message)
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/updateVersionStatus',
                data: versionInfo,
            }).then(response => {
            });
            this.$store.dispatch('addNotification', {title: 'Accepted (' + request.id + ')', text: 'The request has been accepted.', type: 'success'});
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/adminLoadLatestPublishRequests',
            })
            .then(resp => {
                this.latestPublishRequests = resp.data;
            });
        },
        decline(request) {
            var versionInfo = new FormData();
            versionInfo.append('task', 'declinePublish')
            versionInfo.append('version_id', request.id)
            versionInfo.append('to', request.user_email)
            versionInfo.append('name', request.displayname)
            versionInfo.append('company_name', request.company)
            versionInfo.append('company_id', request.company_id)
            versionInfo.append('plugin_name', request.plugin)
            versionInfo.append('plugin_id', request.plugin_id)
            versionInfo.append('version_number', request.number)
            versionInfo.append('user_id', this.$store.state.userData.user_id)
            versionInfo.append('text', request.message)
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/updateVersionStatus',
                data: versionInfo,
            }).then(response => {
                console.log(response);
            });
            this.$store.dispatch('addNotification', {title: 'Declined (' + request.id + ')', text: 'The request has been declined.', type: 'info'});
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/adminLoadLatestPublishRequests',
            })
            .then(resp => {
                this.latestPublishRequests = resp.data;
            });
        },
    },
    created() {
        /*axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/adminLoadLatestCompanies',
        })
        .then(resp => {
            console.log(resp);
            this.latestCompanies = resp.data;
        });*/

        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://api.library.loxone.com/adminLoadLatestPublishRequests',
        })
        .then(resp => {
            this.latestPublishRequests = resp.data;
        });
        
    }
}
</script>

<style lang="scss" scoped>
    li{
        padding-bottom: 10px;
    }

    h2{
        cursor: zoom-in;
    }

    .bar{
        position:relative;
        height: 64px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.15);
        border: 1px solid rgba(0, 0, 0, 0.25);
        margin-bottom: 10px;

        .bar--block{
            background-color: #69C350;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            z-index: 1;
        }
        span{
            line-height: 64px;
            color: #FFFFFF;
            position: absolute;
            top: 0;
            left: 30px;
            bottom: 0;
            z-index: 9999;
            text-shadow: 1px 1px 1px black;
        }

        .max--indicator{
            position: absolute;
            left: 20%;
            z-index: 999;
            top: 0;
            bottom: 0;
            width: 3px;
            background-color: black;
        }
    }
    .interactive{
        cursor: pointer;
    }
    .admin{
        padding: 0 20px 20px 20px;

        height: 100%;
    }

    h2{
        margin: 0;
    }

    .admin__box{
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
        padding: 20px;
        margin-top: 20px;
        background-color: #FFFFFF;

        .content{
            margin-top: 10px;
            overflow-y: auto;
        }

        &.loading{
            background-image: url('https://api.library.loxone.com/files/global/loading.gif');
            background-repeat: no-repeat;
            background-position: center center;
        }

    }

    table{
        width: 100%;
        border-spacing: 0;
        border-collapse: collapse;
        margin-top: 20px;

        thead{
            font-weight: bold;
            
            td{
                border-bottom: 2px solid #000000;
                padding-left: 5px;
            }
        }
        tbody {
            td{
                padding-top: 10px;
                padding-left: 5px;
                padding-bottom: 10px;
                border-bottom: 1px solid black;
            }
        }
    }
    .version--wrapper{
        padding: 10px 20px 30px 20px
    }
    .plugin--row td{
        cursor: pointer;
    }

    h3 {
        margin: 0;
    }
</style>